import { render, staticRenderFns } from "./ComponentDialog.vue?vue&type=template&id=597b7d31&scoped=true"
import script from "./ComponentDialog.vue?vue&type=script&lang=js"
export * from "./ComponentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597b7d31",
  null
  
)

export default component.exports